var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio-list"},[_c('ListHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"list-items"},_vm._l((_vm.portfolioItems),function(item){return _c('PortfolioItem',{key:item.id,attrs:{"item":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }